import { gql } from "@urql/core";

export const INVOICE_QUERY = gql`
  query Invoices(
    $filter: JSONObject
    $sorting: [SortInput!]
    $paging: PaginationInput
  ) {
    invoices(query:{filter: $filter, sorting: $sorting, paging: $paging}) {
      nodes {
        id
        supplierId
        supplierName
        invoiceNumber
        poId
        poNumber
        deliveryRefs
        currency
        subtotal
        tax
        totalAmount
        items {
          poLineId
          description
          acceptedQty
          invoicedQty
          poUnitPrice
          invoiceUnitPrice
          matchStatus
          remarks
        }
        status
        fileId
        paymentRequestId
        createdAt
        updatedAt
      }
    }
  }
`;

export const INVOICE_BY_ID_QUERY = gql`
  query InvoiceById($id: String!) {
    invoice(id: $id) {
      id
      supplierId
      supplierName
      invoiceNumber
      poId
      poNumber
      deliveryRefs
      currency
      subtotal
      tax
      totalAmount
      items {
        poLineId
        description
        acceptedQty
        invoicedQty
        poUnitPrice
        invoiceUnitPrice
        matchStatus
        remarks
      }
      status
      fileId
      templateId
      approvalType
      externalWorkflow
      submittedBy
      paymentRequestId
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_INVOICE_MUTATION = gql`
  mutation CreateInvoice($input: CreateInvoiceInput!) {
    createInvoice(input: $input) {
      id
      invoiceNumber
      supplierName
      totalAmount
      status
      createdAt
    }
  }
`;

export const UPDATE_INVOICE_MUTATION = gql`
  mutation UpdateInvoice($id: String!, $input: UpdateInvoiceInput!) {
    updateInvoice(id: $id, input: $input) {
      id
      invoiceNumber
      supplierName
      totalAmount
      status
      updatedAt
    }
  }
`;

export const DELETE_INVOICE_MUTATION = gql`
  mutation DeleteInvoice($id: String!) {
    deleteInvoice(id: $id) {
      id
    }
  }
`;

export const APPROVE_INVOICE_MUTATION = gql`
  mutation ApproveInvoice($id: String!, $remarks: String) {
    approveInvoice(id: $id, remarks: $remarks) {
      id
      status
      updatedAt
    }
  }
`;

export const REJECT_INVOICE_MUTATION = gql`
  mutation RejectInvoice($id: String!, $remarks: String) {
    rejectInvoice(id: $id, remarks: $remarks) {
      id
      status
      updatedAt
    }
  }
`;

export const SUBMIT_INVOICE_MUTATION = gql`
  mutation SubmitInvoice($input: SubmitInvoiceInput!) {
    submitInvoice(input: $input) {
      id
      status
      approvalType
      externalWorkflow
      submittedBy
    }
  }
`;